import { Link } from "../router";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link
      className={`brand${compact ? " brand--compact" : ""}`}
      to="/"
      aria-label="F-Bucks – Startseite"
    >
      <img className="brand__coin" src="/logo-fbucks.svg" alt="" width="52" height="52" />
      {!compact && (
        <span className="brand__wordmark" aria-hidden="true">
          <strong>F‑BUCKS</strong>
          <small>PRIVATE ARCADE</small>
        </span>
      )}
    </Link>
  );
}
